<template>
  <div class="snapshot-overlay">
    <div class="snapshot-container">
      <div class="snapshot-content">
        <v-icon icon="msf:tablet_camera" :size="60" color="#EEEEEE" class="mb-2" />
        <template v-if="user.isAssistant">{{ $t('meeting.snapshot.taking') }}</template>
        <template v-if="!user.isAssistant">
          <b v-if="user.isClient">{{ $t('meeting.snapshot.holdStill') }}</b>
          {{ $t('meeting.snapshot.assistantTaking') }}
        </template>
        <svg
          class="corner top-left"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_1106_47696" fill="white">
            <path d="M0 0H36V36H0V0Z" />
          </mask>
          <path
            d="M0 0V-2H-2V0H0ZM0 0V2H36V0V-2H0V0ZM0 36H2V0H0H-2V36H0Z"
            fill="#DCDCDC"
            mask="url(#path-1-inside-1_1106_47696)"
          />
        </svg>
        <svg
          class="corner bottom-left"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_1106_47697" fill="white">
            <path d="M0 0H36V36H0V0Z" />
          </mask>
          <path
            d="M0 36H-2V38H0V36ZM36 36V34H0V36V38H36V36ZM0 36H2V0H0H-2V36H0Z"
            fill="#DCDCDC"
            mask="url(#path-1-inside-1_1106_47697)"
          />
        </svg>
        <svg
          class="corner bottom-right"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_1106_47711" fill="white">
            <path d="M0 0H36V36H0V0Z" />
          </mask>
          <path
            d="M36 36V38H38V36H36ZM36 0H34V36H36H38V0H36ZM36 36V34H0V36V38H36V36Z"
            fill="#DCDCDC"
            mask="url(#path-1-inside-1_1106_47711)"
          />
        </svg>
        <svg
          class="corner top-right"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_1106_47710" fill="white">
            <path d="M0 0H36V36H0V0Z" />
          </mask>
          <path
            d="M36 0H38V-2H36V0ZM0 0V2H36V0V-2H0V0ZM36 0H34V36H36H38V0H36Z"
            fill="#DCDCDC"
            mask="url(#path-1-inside-1_1106_47710)"
          />
        </svg>
        <v-btn variant="outlined" v-if="displayCancel" @click="cancelSnapshot">{{ $t('meeting.snapshot.cancel') }}</v-btn>
      </div>
    </div>
  </div>
</template>
<script setup>
import {useSnapshot} from '@/composables/useSnapshot'
import {useUserStore} from '@/stores'
import {useTimeout} from '@vueuse/core'
import {storeToRefs} from 'pinia'
import {useSnapshotOverlayStore} from '../stores/snapshotOverlayStore'
const user = useUserStore()
const {snapshotOverlayWidth, snapshotOverlayHeight, snapshotOverlayLeft, snapshotOverlayTop} =
  storeToRefs(useSnapshotOverlayStore())
const {cancelSnapshot} = useSnapshot()
const displayCancel = useTimeout(5000)
</script>
<style lang="scss" scoped>
.snapshot-overlay {
  position: absolute;
  z-index: ($zindex-overlay + 1);
  background: #0000007a;
  color: #eeeeee;
  width: 100vw;
  height: 100vh;
  .snapshot-container {
    height: v-bind(snapshotOverlayHeight);
    width: v-bind(snapshotOverlayWidth);
    top: v-bind(snapshotOverlayTop);
    left: v-bind(snapshotOverlayLeft);
    position: absolute;
    .snapshot-content {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .corner {
        position: absolute;
      }
      .top-left {
        top: 24px;
        left: 24px;
      }
      .top-right {
        top: 24px;
        right: 24px;
      }
      .bottom-left {
        bottom: 24px;
        left: 24px;
      }
      .bottom-right {
        bottom: 24px;
        right: 24px;
      }
    }
  }
}
</style>
